import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { IconArrowLeft, IconGenderMale, IconGenderFemale, IconGenderAgender } from "@tabler/icons-react";
import { addAthlete } from "../../db"; // Import Dexie.js functions
import { useNavigate } from "react-router-dom";
import EditAthlete from "../../Components/EditForms/Athlete";

const Athletes = () => {
    const [selectedGender, setSelectedGender] = useState(""); // Track selected radio
    const [nickname, setNickname] = useState("");
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [email, setEmail] = useState("");
    const navigate = useNavigate();

    const handleSave = async () => {
        if (isValid()) {
            const athlete = {nickname, firstname, lastname, email, gender: selectedGender};
            await addAthlete(athlete);
            navigate("/athletes");
        }
    };

    const isValid = () => {
        return true;
    }

    const { t } = useTranslation();

    return (
        <div className="p-4 flex flex-col h-full relative">
            <div className="flex items-center pb-4 w-full">
                <div className="shrink-0 w-10">
                    <Link to="/athletes">
                        <IconArrowLeft className="w-6 h-auto" />
                        <span className="sr-only">{t("athletesNew.backToList")}</span>
                    </Link>
                </div>
                <h1 className="grow text-2xl uppercase text-center font-black transform -skew-x-12 shrink-0">{t("athletesNew.headline")}</h1>
                <div className="shrink-0 w-10"></div>
            </div>

            <div>
                <EditAthlete />
            </div>
        </div>
    );
};

export default Athletes;